import APIService from '.';

export enum PlaidConnectSourceTypeEnum {
  BUSINESS = 'business',
  CUSTOMER = 'customer'
}

export enum PlaidConnectStatusEnum {
  PENDING = 'pending',
  LINKED = 'linked'
}

export interface CreatePlaidConnectResponse {
  sourceId: string;
  sourceType: PlaidConnectSourceTypeEnum;
  linkToken: string;
  linkTokenExpiration: string;
  requestIds: string[];
  status: PlaidConnectStatusEnum;
}

export interface ConnectPlaidConnectResponse
  extends CreatePlaidConnectResponse {
  publicToken: string;
  accessToken: string;
  itemId: string;
}

export interface FindPlaidConnectResponse extends CreatePlaidConnectResponse {}

export default class PlaidService extends APIService {
  async initilize() {
    const { data } = await this.post<CreatePlaidConnectResponse>(
      '/plaid/connect'
    );

    return data;
  }

  async connect(publicToken: string, accountId: string) {
    const { data } = await this.put<ConnectPlaidConnectResponse>(
      '/plaid/connect',
      {
        publicToken,
        accountId
      }
    );

    return data;
  }

  async find() {
    const { data } = await this.get<FindPlaidConnectResponse>('/plaid/connect');

    return data;
  }
}
